// src/components/CookieConsent.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const STORAGE_KEY = 'cookieConsent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(
    () => localStorage.getItem(STORAGE_KEY) !== 'accepted'
  );

  if (!visible) return null;

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie consent">
      <p className="cookie-text">
        This site uses cookies to keep you logged in and improve your experience.
        By continuing to use this site, you accept our use of cookies.
      </p>
      <div className="cookie-actions">
        <button className="btn btn-primary btn-sm cookie-accept" onClick={handleAccept}>
          Accept
        </button>
        <Link to="/privacy" className="cookie-privacy-link">
          Privacy Policy
        </Link>
      </div>
    </div>
  );
};

export default CookieConsent;
